module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai0422-6241b13cebab8d385c98a28e1dd2a91e.jpg";